import React, { useState } from 'react';
import Theme from '../theme';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, StyleSheet, Text, Platform, Keyboard } from 'react-native';
import { getNextStep, navigateToNextStep } from './actions';
import { defaultScale } from '../utils/scaling';
import { SignupScreen } from 'fitbeat.gym-core';
import { MetricToImperialConverter } from 'fitbeat.models';
import { Button } from '../components';
import { HeightField } from '../ui';
import { reduxForm, formValueSelector, isInvalid } from 'redux-form';
import { usesMetricSystem } from 'react-native-localize';
import { UserDataConsumer } from '../utils';
import { acceptInvite } from '../Bookings/actions';

const useImperialUnit = !usesMetricSystem();

const getHeight = (height) => {
  return useImperialUnit ? MetricToImperialConverter.convertInchesAndFeetToCentimeters(JSON.parse(height)) : height;
};

const HomeHeight = ({
  t,
  navigation,
  getNextStep,
  navigateToNextStep,
  height,
  formIsInvalid,
  isLoading,
  handleSubmit,
}) => {

  const [localLoading, setLocalLoading] = useState(false);

  const setHeightAndNavigateToNextStep = async () => {
    if (Platform.OS === 'android') {
      setLocalLoading(true);
      Keyboard.dismiss();
      setTimeout(async () => {
        await goToNextStep()
        setLocalLoading(false);
      })
    } else {
      await goToNextStep()
    }
  }

  const goToNextStep = async () => {
    await getNextStep({
      userProfile: { height: getHeight(height) },
      currentScreen: SignupScreen.Height,
    });
    navigateToNextStep(navigation);
  };

  return (
    <View style={styles.container}>
      <View>
        <Text
          style={[Theme.textStyle.heading, { marginBottom: defaultScale(6) }]}
        >
          {t('whatIsYourHeight')}
        </Text>
        <Text
          style={[
            Theme.textStyle.bodyCopyReg,
            { color: Theme.GREY_MEDIUM, marginBottom: defaultScale(24) },
          ]}
        >
          {t('personalizeFitnessJourneyHeight')}
        </Text>
        <HeightField
          hasPlaceholder={false}
          useImperialUnit={useImperialUnit}
          autoFocus={true}
          onSubmitEditing={handleSubmit(setHeightAndNavigateToNextStep)}
        />
        <Text
          style={[
            Theme.textStyle.bodyCopyReg,
            {
              textAlign: 'center',
              marginTop: defaultScale(7),
              color: Theme.GREY_MEDIUM,
            },
          ]}
        >
          {t('okayToEstimate')}
        </Text>
      </View>
      <Button
        title={t('next')}
        isLoading={isLoading || localLoading}
        disabled={formIsInvalid || !height}
        fontColor={Theme.WHITE}
        onPress={handleSubmit(setHeightAndNavigateToNextStep)}
        overrideFontStyles={[
          Theme.textStyle.bodyCopyBold,
          { color: Theme.WHITE },
        ]}
        containerStyle={{
          height: defaultScale(45),
          width: '100%',
          marginTop: defaultScale(28),
          marginBottom: defaultScale(30),
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: defaultScale(16),
    backgroundColor: Theme.WHITE,
    justifyContent: 'space-between',
  },
  bookingSelectionTitle: {
    fontSize: Theme.textStyle.heading.fontSize,
    fontFamily: Theme.textStyle.heading.fontFamily,
    textAlign: 'center',
  },
});

const mapStateToProps = (state) => {
  const fieldName = useImperialUnit ? 'heightImperial' : 'height';
  return {
    userProfile: state.auth.signup.userProfile,
    isLoading: state.auth.signup.isLoading,
    height: formValueSelector('HomeHeightForm')(state, fieldName),
    formIsInvalid: isInvalid('HomeHeightForm')(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getNextStep: (nextStepArguments) => dispatch(getNextStep(nextStepArguments)),
  navigateToNextStep: (navigation, options) => dispatch(navigateToNextStep(navigation, options)),
  acceptInvite: (workoutSession) => dispatch(acceptInvite(workoutSession)),
});

export const HomeHeightScreen = translate(['auth'], { wait: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(reduxForm({ form: 'HomeHeightForm' })(UserDataConsumer(HomeHeight))),
);
